import { NotificationType } from '../../../../../services/exports/Constants';

export default {
  title: 'Masz {{length}} alertów',
  notifications: {
    titles: {
      [NotificationType.PaymentGatewayVerificationPending]: 'Dane płatności w trakcie weryfikacji',
      [NotificationType.PaymentGatewayVerificationSuccessful]: 'Dane płatności zweryfikowane',
      [NotificationType.PaymentGatewayVerificationFailed]: 'Błąd danych płatności',
    },
    descriptions: {
      [NotificationType.PaymentGatewayVerificationPending]:
        'Twoje dane płatności są weryfikowane przez Stripe. Może to potrwać do 48 godzin.',
      [NotificationType.PaymentGatewayVerificationSuccessful]:
        'Twoje dane płatności zostały pomyślnie zweryfikowane. Możesz teraz przyjmować płatności.',
      [NotificationType.PaymentGatewayVerificationFailed]:
        'Wygląda na to, że wystąpił błąd z Twoimi danymi. Kliknij tutaj, aby zaktualizować dane.',
    },
  },
};
